class TeamSection {
    constructor(element) {
        this.element = element;
        this.swiperElement = element.querySelector('[data-team-swiper]');
        this.swiperInstance = null;

        this.init();
    }

    init() {
        if (this.swiperElement) {
            this.initSwiper();
            this.handleResize();
        }
    }

    initSwiper() {
        if (window.innerWidth <= 768) {
            this.createSwiper();
        }
    }

    createSwiper() {
        if (this.swiperInstance) return;

        this.swiperInstance = new Swiper(this.swiperElement, {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: false,
            speed: 400,
            effect: 'slide',
            grabCursor: true,
            watchSlidesProgress: true,
        });
    }

    destroySwiper() {
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
    }

    handleResize() {
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if (window.innerWidth <= 768 && !this.swiperInstance) {
                    this.createSwiper();
                } else if (window.innerWidth > 768 && this.swiperInstance) {
                    this.destroySwiper();
                }
            }, 250);
        });
    }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    const teamSections = document.querySelectorAll('.team-section');
    teamSections.forEach(section => new TeamSection(section));
});

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector('.team-section');
        if (section) new TeamSection(section);
    });

    document.addEventListener('shopify:section:unload', (event) => {
        const section = event.target.querySelector('.team-section');
        const teamInstance = section?._teamInstance;
        if (teamInstance) {
            teamInstance.destroySwiper();
        }
    });
}